import { Component, EventEmitter, OnDestroy, Input, Output, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { User } from '../../../models/user';
import {
	LegalDocumentService, LEGAL_DOCUMENT_FIELD
} from '../../../services/legal-document.service';
import { UserService } from '../../../services/user.service';
import { OrderBy, OrderByDirection } from '../../../utils/constant';

@Component({
	selector: 'copo-legal-document-agreement',
	templateUrl: './legal-document-agreement.component.html',
	styleUrl: './legal-document-agreement.component.css',
	imports: [
		NgIf,
		TranslateModule,
		RouterLink,

		MatCheckboxModule,
	],
})

export class LegalDocumentAgreementComponent implements OnInit, OnDestroy {
	@Output() readonly userAgreementCheck = new EventEmitter<
		{
			agreedToSalesConditions: boolean;
			notAgreedLegalDocumentIds: number[];
			isLoading: boolean;
		}
	>(true);

	@Input() serviceCode!: string;
	@Input() legalDocumentLabel!: string;

	user: User;
	title!: string;
	checked = false;
	notAgreedLegalDocumentIds: number[] = [];

	legalDocumentsSub?: Subscription;
	isLoading = true;

	constructor(
		private readonly userService: UserService,
		private readonly legalDocumentService: LegalDocumentService
	) {
		this.user = this.userService.user;
	}

	ngOnInit() {
		if (this.user.isDelegating()) {
			this.isLoading = false;
			this.onAgreementCheckboxChange(this.notAgreedLegalDocumentIds.length === 0);
			return;
		}
		this.legalDocumentsSub = this.legalDocumentService.getLegalDocument(
			LEGAL_DOCUMENT_FIELD,
			this.legalDocumentService.createLuceneAgreementFilter(this.serviceCode),
			1,
			1000,
			new OrderBy('areaRef', OrderByDirection.ASC),
			false
		)
			.subscribe({
				next: res => {
					const legalDocuments = res.results;
					this.notAgreedLegalDocumentIds = legalDocuments.filter(legalDocument =>
						legalDocument.userAgreements.length === 0).map(legalDocument => legalDocument.id);
					this.isLoading = false;
					this.onAgreementCheckboxChange(this.notAgreedLegalDocumentIds.length === 0);
				}
			});
	}

	ngOnDestroy(): void {
		this.legalDocumentsSub?.unsubscribe();
	}

	onAgreementCheckboxChange(agreedToSalesConditions: boolean) {
		const { notAgreedLegalDocumentIds } = this;
		const { isLoading } = this;
		this.userAgreementCheck.emit({ agreedToSalesConditions, notAgreedLegalDocumentIds, isLoading });
	}
}
